$(document).ready(function(){

	/* EMAIL OBFUSCATION */
	/* Randomly generated random strings, just because of random */
	var atRndStr = '6GWP7iLvhA';
	var periodRndStr = 'Mw1kbytG99';

	$('.email').each(function(i, obj) {
		var email = unobfuscate($(this).attr('href'));
		email = email.replace('mailto:', '');
		$(this).text(email);
	});

	$('.email').mouseover(function(){
		var email = unobfuscate($(this).attr('href'));
		$(this).attr('href', email);
	});

	$('.email').mouseout(function(){
		var email = obfuscate($(this).attr('href'));
		$(this).attr('href', email);
	});

	function unobfuscate(s)
	{
		var reg = new RegExp(periodRndStr,'g');
		s = reverse(s);
		s = rot13(s);
		s = s.replace(atRndStr, '@');
		s = s.replace(reg, '.');
		return s;
	}

	function obfuscate(s)
	{
		s = s.replace('@', atRndStr);
		s = s.replace(/\./g, periodRndStr);
		s = reverse(s);
		s = rot13(s);
		return s;
	}

	function reverse(s) {
		return s.split("").reverse().join("");
	}

	function rot13(s)
	{
		return (s ? s : this).split('').map(function(_)
		{
			if (!_.match(/[A-Za-z]/)) return _;
			const c = Math.floor(_.charCodeAt(0) / 97);
			const k = (_.toLowerCase().charCodeAt(0) - 83) % 26 || 26;
			return String.fromCharCode(k + ((c == 0) ? 64 : 96));
		}).join('');
	}
});